export default __webpack_public_path__ + "0c2496fa48256b6f85d58a140dc0da34.jpg";